import { render } from "./TheLoseModal.vue?vue&type=template&id=150cb984"
import script from "./TheLoseModal.vue?vue&type=script&lang=js"
export * from "./TheLoseModal.vue?vue&type=script&lang=js"
script.render = render

export default script